/*
* TODO: Rename to adalia_me_tranche_selection (already in use, needs migration)
* 
* Disbursement component specific for Adalia M&E. 
* 
* Project can be passed as a prop, but if not, this component expects the document to contain an element with an id report-container
* and that element have a data-attribute called project-id.
* 
* Loads the planned tranches as options
*/
import React from 'react';
import { fetchJson } from '../../../helpers/fetch.js';
import {
  Mode,
  castDataType,
  DataType,
} from '../common.jsx';
import Helpers from './helpers.jsx';
import Setting from './setting.jsx';

import GridLayout from './grid_layout.jsx';
import AdaliaMEDisbursement from './adalia_me_disbursement.jsx';
import DropdownSelectionWithAsyncOptions from './dropdown_selection_with_async_options.jsx';
import MultiDropdownSelection from './multi_dropdown_selection.jsx';
import TextField from './text_field.jsx';

import Resolver from '../component_resolver.jsx';


import {
  payment_contract_list_json_path,
  payment_type_list_names_path
} from '~/routes';

const PAYMENT_STATUS = {
  PLANNED: 'planned'
}

export default class AdaliaMETrancheCollection extends GridLayout {
  static get CATEGORY() {
    return "question";
  }

  static get TYPE() {
    // Tranche selection
    return "adalia_me_tranche_collection";
  }

  static icon() {
    return <i className="fa fa-money"></i>;
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: "field_tranche_collection_default_label",
      description: "field_tranche_collection_default_description",
      help: null,
      blankOptionLabel: "select_blank_option_default",
    };
  }

  static disallowMultiple() {
    return true;
  }

  static dropAllowed(dropArea, droppedContent, components, isNested) {
    if (!super.dropAllowed(dropArea, droppedContent, components, isNested)) {
      return false;
    }

    if (components != undefined) {
      for (var i = 0; i < components.length; i++) {
        const comp = components[i];
        if (
          [comp, ...Resolver.componentClass(comp.type).nestedComponents(components[i])].find(
            (c) => c.type === "adalia_me_disbursement"
          )
        ) {
          alert(I18n.t('alert_tranche_and_disbursement_in_same_form', {scope: 'fe'}));
          return false;
        }
      }
    }

    return true;
  }

  static defaultContent(language) {
    let fieldName = "field_" + Helpers.randomString();

    let trancheContent = Object.assign(AdaliaMEDisbursement.defaultContent(language), {
      deletable: false,
      sortable: false,
      allowMultiple: true,
      dependentOptions: fieldName + "_contract",
      name: fieldName + "_tranches",
      typeName: fieldName + "_types",
      disbursementName: fieldName + "_disbursement_number",
    });

    return Object.assign(super.defaultContent(language), {
      name: fieldName,
      rows: [
        [
          // Contract selection
          {
            span: 1,
            component: Object.assign(AdaliaMEPaymentContractSelect.defaultContent(language), {
              deletable: false,
              sortable: false,
              allowMultiple: false,
              name: fieldName + "_contract",
            }),
          },
        ],
        [
          {
            span: 1,
            component: trancheContent,
          },
        ],
        [
          {
            span: 1,
            component: Object.assign(AdaliaMEPaymentTypeSelect.defaultContent(language), {
              deletable: false,
              sortable: false,
              allowMultiple: true,
              includeBlank: true,
              name: fieldName + "_types",
            }),
          },
          {
            span: 1,
            component: Object.assign(AdaliaMEPaymentDisbursementNumber.defaultContent(language), {
              deletable: false,
              sortable: false,
              name: fieldName + "_disbursement_number",
            }),
          },
        ],
      ],
    });
  }

  componentDidMount() {
    super.componentDidMount();

    if (typeof this.props.updateSettingsCallback == 'function') {
      let content = this.props.content;
      if (content.isNewComponent) {
        content.rows[0].forEach((comp, i) => {
          content.rows[0][i].component.isNewComponent = true;
        })
        content.rows[1][0].component.isNewComponent = true;
        this.props.updateSettingsCallback(content.id, content, true);
      }
    }
  }

  renderSettings() {
    return (
      <>
        <Setting.Checkbox
          name="autoSelectNextTranche"
          label={I18n.t('auto_select_next_tranche', {scope: 'fe'})}
          value={this.props.content.autoSelectNextTranche}
          onChange={this.updateSettings}
        />
        <p className="description">{I18n.t('auto_select_next_tranche_description', {scope: 'fe'})}</p>
      </>
    );
  }

  componentProps(_comp) {
    // The auto_select needs to be passed to childs
    return {
      autoSelectNextTranche: this.props.content.autoSelectNextTranche,
    };
  }

  beforeUpdateSettings(content, deletedRowIndex, deletedColIndex) {
    // Rows are pre-set, skip (see super)
    content.autoSelectNextTranche =
      typeof content.autoSelectNextTranche == "boolean"
        ? content.autoSelectNextTranche
        : castDataType(content.autoSelectNextTranche, DataType.BOOLEAN);
  }
}

const fetchPaymentContracts = (project_id, cb) => {
  fetchJson(payment_contract_list_json_path({ project_id })).then(
    (res) => {
      cb(res);
    }
  );
}


export class AdaliaMEPaymentContractSelect extends DropdownSelectionWithAsyncOptions { 
  static get TYPE() {
    return 'adalia_me_payment_contract_selection';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_payment_contract_selection_default_label',
      description: 'field_payment_contract_selection_default_description',
      help: null,
      blankOptionLabel: 'select_blank_option_default'
    };
  }

  static get SETTINGS_DUMMY_DATA() {
    return [
        { value: 1, label: 'Example contract 1', disbursement_identifier: 1, payment_contract_id: 1 },
        { value: 2, label: 'Example contract 2', disbursement_identifier: 1, payment_contract_id: 2 },
    ];
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
        name: 'contract_selection',
        reportKey: '',
        help: null,
    });
  }

  renderSettings() {
    return <>
      <Setting.Checkbox name="required" label={I18n.t('field_required', {scope: 'fe'})} value={this.props.content.required} onChange={this.updateSettings} />
      <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField
        name="reportKey"
        label={I18n.t('field_report_key', {scope: 'fe'})}
        value={this.props.content.reportKey}
        description={I18n.t('field_report_key_description', {scope: 'fe'})}
        {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
      />
    </>
  }

  componentDidMount() {
    super.componentDidMount();

    let project_id = this.props.project?.id || jQuery('#report-container').data('project-id');

    if (!project_id || [Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
      this.setState({ options: this.constructor.SETTINGS_DUMMY_DATA, loading: false });
    } else {
      fetchPaymentContracts(project_id, (res) => {
        if (res) {
          this.setState({
            options: res,
            loading: false,
          })
        }
      });
    }
  }
}


const fetchPaymentTypes = (cb) => {
  fetchJson(payment_type_list_names_path()).then(
    (res) => {
      cb(res);
    }
  );
}

export class AdaliaMEPaymentTypeSelect extends MultiDropdownSelection {
  static get TYPE() {
    return 'adalia_me_payment_type_selection';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_payment_type_selection_default_label',
      description: 'field_payment_type_selection_default_description',
      help: '',
      blankOptionLabel: '-',
      placeholder: '-',
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
        reportKey: '',
        help: '',
    });
  }

  loadPaymentTypeNames = (e) => {
    e.preventDefault(); e.stopPropagation();
    fetchPaymentTypes((res) => {
      if (res) {

        this.props.updateSettingsCallback(this.props.content.id, {
          ...this.props.content, 
          options: [{
            dependency: '_default',
            options: res.map(r => ({value: r, label: r})) 
          }]
        }, true);
      }
    });
  }

  renderSettings() {
    let options = ((this.props.content.options || {})[0] || {}).options || [];

    return <>
      <span className='description'>{I18n.t('payment_type_settings_description', {scope: 'fe'})}</span>
      <Setting.Checkbox name="hiddenField" label={I18n.t('field_hidden', {scope: 'fe'})} value={this.props.content.hiddenField} onChange={this.updateSettings} />
      <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.TextField name="reportKey" label={I18n.t('field_report_key', {scope: 'fe'})} value={this.props.content.reportKey} onChange={this.updateSettings} description={I18n.t('field_report_key_description', {scope: 'fe'})} />

      <div className="setting">
        <label>{I18n.t('payment_types')}</label>
        {options.map(o => <div key={o.value}>{o.label}</div>)}
        <input type='hidden' value={options.map(o => o.value)} name='options'/>
        <button className='btn btn-sm btn-primary' onClick={this.loadPaymentTypeNames}>{I18n.t('sync')}</button>
      </div>
    </>
  }

  renderView() {
    if (this.props.content.hiddenField) {
      return <div className='hidden-field'>{super.renderView()}</div>
    }
    return super.renderView();
  }

  getText(key) {
    let label = super.getText(key);
    // No translations for options. Return key
    if (label == '' && key != 'help') return key;
    return label;
  }

  // Never modified by user. Gets updated by disburesment component
  isReadOnlyAnswer() {
    return true
  }

  beforeUpdateSettings(content) {
    super.beforeUpdateSettings(content);
    content.hiddenField = castDataType(content.hiddenField, DataType.BOOLEAN);
  }

}
export class AdaliaMEPaymentDisbursementNumber extends TextField {
  static get TYPE() {
    return 'adalia_me_disbursement_number';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'field_disbursement_number_default_label',
      description: 'field_disbursement_number_default_description',
      help: null,
      unit: null,
      placeholder: '-',
      // blankOptionLabel: 'select_blank_option_default'
    };
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
        reportKey: '',
        unit: null,
        help: null
    });
  }

  renderSettings() {
    return <>
      <span className='description'>{I18n.t('payment_disbursement_number_settings_description', {scope: 'fe'})}</span>
      <Setting.Checkbox name="hiddenField" label={I18n.t('field_hidden', {scope: 'fe'})} value={this.props.content.hiddenField} onChange={this.updateSettings} />
      <Setting.TextField name="label" label={I18n.t('field_label', {scope: 'fe'})} value={this.getText('label')} onChange={this.updateSettings} />
      <Setting.Checkbox name="label_hidden" className="label-hidden-check" label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
      <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
      <Setting.LongTextField name="help" label={I18n.t('field_help', {scope: 'fe'})} value={this.getText('help')} onChange={this.updateSettings} />
      <Setting.TextField name="reportKey" label={I18n.t('field_report_key', {scope: 'fe'})} value={this.props.content.reportKey} onChange={this.updateSettings} description={I18n.t('field_report_key_description', {scope: 'fe'})} />

    </>
  }

  
  componentDidUpdate(prevProps) {
    super.componentDidUpdate();
  }
  // Never modified by user. Gets updated by disburesment component
  isReadOnlyAnswer() {
    return true
  }

  renderView() {
    return (
        <div className={this.props.content.hiddenField ? 'hidden-field' : ''}>
          {this.getLockedInformationTooltip(this.modeFillOrView() && this.isReadOnlyPrefilledAnswer(), <>
              <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                <span className='field-label'>{this.getText('label')}</span>
                {this.helpIcon()}
              </label>
              <div className="input-container">
                    <div>
                        <input ref="input" type="text" 
                            className={`form-control locked ${this.getInputClassNames()}`}
                            name={this.fullFieldName()}
                            value={this.getRawAnswer()}
                            title={''}
                            placeholder={this.getText('placeholder')}
                            disabled={this.props.content.disabled === true}
                            readOnly={this.props.mode != Mode.FILL || this.isReadOnlyAnswer()}
                            autoComplete={this.getAutoComplete()}
                          />
                    </div>
              </div>
            {this.descriptionText()}
            {!this.modeFillOrView() && this.isReadOnlyAnswer() ? this.lockedInformationDefault() : ''}
          </>)}
        </div>
    );
}

  beforeUpdateSettings(content) {
    super.beforeUpdateSettings(content);
    content.hiddenField = castDataType(content.hiddenField, DataType.BOOLEAN);
  }
}